import { __makeTemplateObject } from "tslib";
import { spacing, styled, typography } from '../../../../../foundation';
import { StyledTimeIconButton } from './StyledTimeIconButton';
export var StyledSelectionItem = styled(StyledTimeIconButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    ", ";\n    /* when itemLength is 4 which makes it to become two line, so add padding for it. */\n    margin: ", ";\n  }\n"], ["\n  && {\n    ", ";\n    /* when itemLength is 4 which makes it to become two line, so add padding for it. */\n    margin: ",
    ";\n  }\n"])), typography('body1'), function (_a) {
    var itemLength = _a.itemLength, wrapperSize = _a.wrapperSize;
    return spacing(wrapperSize === 'small' && itemLength === 4 ? 2 : 1);
});
var templateObject_1;
